import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../../../components/common/Loading';
import Notification from '../../../components/common/Notification';
import Tabs from '../../../components/common/Tabs';
import VacancyForm from '../../../components/module/rec/vacancy/VacancyForm';
import VacancyJDForm from '../../../components/module/rec/vacancy/VacancyJDForm';
import VacancyQuestionsForm from '../../../components/module/rec/vacancy/VacancyQuestionsForm';
import VacancyUploadForm from '../../../components/module/rec/vacancy/VacancyUploadForm';
import { useNotification } from '../../../hooks/useNotification';
import { PAGE_IDS } from '../../../constants/permissions';
import { APP_ROUTES } from '../../../constants/routes';
import { menuService } from '../../../services/menu.service';

const EditVacancy: React.FC = () => {
  const [tabs, setTabs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<any>();
  const navigate = useNavigate();
  const { notification, hideNotification, showNotification } = useNotification();

  useEffect(() => {
    const fetchTabs = async () => {
      try {
        setIsLoading(true);
        const response = await menuService.getTabs(PAGE_IDS.VACANCY_EDIT);

        const apiTabs = (response.data.data ?? []).map((tab) => ({
          label: tab.name,
          value: tab.menuId,
        }));

        setActiveTab(apiTabs[0]?.value);
        setTabs(apiTabs);
      } catch (error) {
        console.error('Error fetching tabs:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTabs();
  }, []);

  const handleTabChange = (value: string) => {
    hideNotification();
    setActiveTab(value);
  };

  const handleSuccess = (message?: string) => {
    showNotification(message ?? 'Success', 'success', 'Success');
  };

  const handleError = (message?: string) => {
    showNotification(message ?? 'Error', 'error', 'Error!');
  };

  const handleCancel = () => {
    navigate(APP_ROUTES.VACANCY.SEARCH);
  };

  const renderContent = () => {
    switch (activeTab) {
      case tabs[0]?.value:
        return (
          <VacancyForm
            type="edit"
            onCancel={handleCancel}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        );
      case tabs[1]?.value:
        return (
          <VacancyJDForm
            type="edit"
            onCancel={() => setActiveTab(tabs[0]?.value)}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        );
      case tabs[2]?.value:
        return (
          <VacancyUploadForm
            type="edit"
            onCancel={() => setActiveTab(tabs[1]?.value)}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        );
      case tabs[3]?.value:
        return (
          <VacancyQuestionsForm
            type="edit"
            onCancel={() => setActiveTab(tabs[2]?.value)}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        );
      default:
        return null;
    }
  };

  return (
      <Box className="page-container" p={3}>
        {isLoading ? (
          <Loading />
      ) : (
        <>
          <Typography className="page-title">
            Edit Vacancy
          </Typography>
          <Box mb={3}>
            <Tabs
              tabs={tabs}
              value={activeTab}
              onChange={handleTabChange}
            />
          </Box>
          {renderContent()}
        </>
      )}

      {/* Notification Component */}
      <Notification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        severity={notification.severity}
        title={notification.title}
      />
      </Box>
  );
};

export default EditVacancy; 
